// delegated-g3-release-secrets-policy.ts — security F-03 + L-01 (06k review).
//
// G3 do Claude duyệt ủy nhiệm (grant `source: chat_delegated` trong gates.json) +
// `run --detach` từ shell Claude Code ⇒ con kế thừa credential sẵn trong shell:
// deploy chạm môi trường đích mà 0 người đưa secret. Luật: grant ủy nhiệm mà
// không có `--release-secrets-stdin` ⇒ dừng `blocked:release_secrets_stdin_required`
// (không recipe nào spawn); có stdin ⇒ env recipe = env_allowlist ∩ stdin — bỏ
// shell VÀ `test.env` cho key recipe.
import { CHAT_DELEGATED_SOURCE } from "./chat-delegated-attribution.js";
import type { ReleaseSecretsStdin } from "./release-secrets-stdin-reader.js";
import type { ReleaseFlowResumeOutcome } from "./supervisor-release-flow-resume-outcome.js";

export const RELEASE_SECRETS_STDIN_REQUIRED_REASON =
  "G3 duyệt ủy nhiệm (chat_delegated) — secret release chỉ nhận qua `--release-secrets-stdin` " +
  "do người đưa; không lấy shell/test.env. Chưa recipe nào chạy.";

/** Phần allowlist của recipe release (deploy + smoke) — chỉ cần tên key. */
interface ReleaseAllowlists {
  deploy_recipe?: { env_allowlist: readonly string[] };
  verify_recipe?: { env_allowlist: readonly string[] };
}

/** N-4: env recipe = allowlist ∩ stdin, KHÔNG có PATH/HOME từ shell ⇒ nói rõ người phải pipe gì. */
export function releaseSecretsStdinRequiredReason(release: ReleaseAllowlists | undefined): string {
  const keys = [
    ...new Set([
      ...(release?.deploy_recipe?.env_allowlist ?? []),
      ...(release?.verify_recipe?.env_allowlist ?? []),
    ]),
  ];
  const listed = keys.length > 0 ? keys.join(", ") : "(env_allowlist trống)";
  return (
    `${RELEASE_SECRETS_STDIN_REQUIRED_REASON} Env recipe = env_allowlist ∩ stdin — shell bị bỏ, ` +
    "kể cả PATH/HOME: người pipe vào stdin MỌI key recipe cần (cả PATH/HOME nếu recipe cần; " +
    `key phải có trong env_allowlist). Key env_allowlist deploy + smoke chưa có ở stdin: ${listed}.`
  );
}

export function isDelegatedG3Grant(g3Source: string | undefined): boolean {
  return g3Source === CHAT_DELEGATED_SOURCE;
}

/** `stop` ⇒ grant ủy nhiệm thiếu stdin (dừng, 0 spawn); `stdinOnly` ⇒ option cho merger env. */
export function delegatedG3ReleaseSecrets(input: {
  g3Source?: string;
  releaseSecretsStdin?: ReleaseSecretsStdin;
  release?: ReleaseAllowlists;
}): { stop?: ReleaseFlowResumeOutcome; stdinOnly: boolean } {
  const stdinOnly = isDelegatedG3Grant(input.g3Source);
  if (!stdinOnly || input.releaseSecretsStdin !== undefined) return { stdinOnly };
  const reason = releaseSecretsStdinRequiredReason(input.release);
  return { stdinOnly, stop: { kind: "release_secrets_stdin_required", reason } };
}
